import { Badge } from 'antd';
import { useTranslation } from 'react-i18next';

import { useHealthReadiness } from '@/api/generated/endpoints/health/health';

export function ApiHealthBadge() {
  const { t } = useTranslation();
  const { isSuccess, isError } = useHealthReadiness({ query: { refetchInterval: 30_000 } });
  const status = isSuccess ? 'success' : isError ? 'error' : 'processing';
  const text = t(isSuccess ? 'health.ok' : isError ? 'health.down' : 'health.checking');
  return <Badge status={status} text={text} />;
}
